import { useQuery } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { pinsQueryKeys } from '../constants'

/**
 * Number of pins of a plan that match a given pin filter. Asks for a single
 * element and reads the `totalElements` page metadata, so it never pulls the
 * whole pin list. `stateFilter` defaults to 'All' to mirror how the plan viewer
 * counts pins once a filter is applied.
 */
export const useGetPlanPinsCountQuery = ({
  planId,
  filterId = null,
  stateFilter = 'All',
  options
}) => {
  const handleQuery = async () => {
    const config = {
      method: 'get',
      params: {
        page: 0,
        size: 1,
        filterId,
        stateFilter
      }
    }

    const { data } = await api(`/api/v2/plans/${planId}/pins`, config)

    return data?.totalElements ?? 0
  }

  return useQuery({
    queryKey: [
      pinsQueryKeys.GET_PLAN_PINS_COUNT,
      planId,
      filterId,
      stateFilter
    ],
    queryFn: handleQuery,
    retry: 0,
    enabled: !!planId,
    ...options
  })
}
